<template>
	<div id="page-wrapper">
		<div class="row page-titles no-print">
			<div class="col-md-5 align-self-center">
				<h3 class="text-themecolor">{{ $t('nav.reimbursement') }} <Help /></h3>
			</div>
			<div class="col-md-7 align-self-center">
				<ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.revenue') }}</a></li>
					<li class="breadcrumb-item active">{{ $t('nav.reimbursement') }}</li>
				</ol>
			</div>
		</div>
		<div class="container-fluid no-print">
			<!-- /row -->
			<div class="row">
				<div class="col-md-12 col-sm-12">
					<div class="card">
						<div class="card-header">
						    <div class="pull-right">
								<el-button type="primary" size="small" round @click="createNew">{{ $t('reimbursement.create') }}</el-button>
							</div>
						    <h5>
								{{ $t('reimbursement.sum') }}: {{ sum[parseInt(activeTab)].toFixed(2) + $t('reimbursement.unit') }}
								<br>
								<span v-if="activeTab == 2">{{ $t('reimbursement.team-accum') }}: {{ reimbursement.team_accumalative + $t('reimbursement.unit') }}; {{ $t('reimbursement.team-left') }}: {{ reimbursement.team_left + $t('reimbursement.unit') }}</span>
								<span v-else>{{ $t('reimbursement.my-accum') }}: {{ reimbursement.my_accumalative + $t('reimbursement.unit') }}; {{ $t('reimbursement.my-left') }}: {{ reimbursement.team_left + $t('reimbursement.unit') }}</span>
							</h5>
						</div>
						<div class="card-body">
							<el-tabs v-model="activeTab">
							    <el-tab-pane :label="$t('reimbursement.my')" name="1">
									<el-table
								    ref="my-re"
								    :data="reimbursement.my"
								    tooltip-effect="dark"
								    style="width: 100%"
								    :summary-method="getSummaries"
    								show-summary
								    @selection-change="handleSelectionChange"
								    @cell-click="handleCellEvent">
								    <el-table-column
								      type="selection"
								      width="55">
								    </el-table-column>
								    <el-table-column
								      prop="typeName"
								      :label="$t('reimbursement.type')"
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="category"
								      :label="$t('reimbursement.category')"
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="legalEntity"
								      :label="$t('reimbursement.legal-entity')"
								      width="150">
								    </el-table-column>
								    <el-table-column
								      prop="amount"
								      :label="$t('reimbursement.amount')"
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="invoiceDate"
								      :label="$t('reimbursement.invoice-date')"
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="status"
								      :label="$t('reimbursement.people')"
								      sortable
								      width="180"
								      >
      								  <template slot-scope="scope">
								        <span v-if="scope.row.personId != null">{{ scope.row.person.name }}@{{ scope.row.person.title }} of {{ scope.row.person.company }}</span>
								        <span v-else>&nbsp;</span>
								      </template>
								    </el-table-column>
								    <el-table-column
								      prop="statusName"
								      :label="$t('reimbursement.status')"
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="comment"
								      :label="$t('reimbursement.comment')"
								      width="200">
								    </el-table-column>
								  </el-table>
								  <el-row style="margin-top:20px">
									<el-button type="primary" @click="printReimbursementSheet" :disabled="canPrint">{{ $t('reimbursement.print') }}</el-button>
									<el-popover
									  placement="top"
									  width="200"
									  trigger="click"
									  v-model="delConfirm">
									  <p>{{ $t('reimbursement.del-confirm') }}</p>
									  <div style="text-align: right; margin: 0">
									    <el-button size="mini" type="primary" @click="deleteSelectedItems">{{ $t('reimbursement.ok') }}</el-button>
									    <el-button size="mini" type="text" @click="delConfirm = false">{{ $t('reimbursement.cancel') }}</el-button>
									  </div>
									  <el-button slot="reference" :disabled="canDelete" style="margin-left:10px">{{ $t('reimbursement.delete') }}</el-button>
									</el-popover>
								  </el-row>
							    </el-tab-pane>
							    <el-tab-pane :label="$t('reimbursement.team')" name="2" v-if="userRole != 0">
							    	<el-input
									    :placeholder="$t('reimbursement.search-ph')"
									    prefix-icon="el-icon-search"
									    v-model="keyword1"
									    style="width:250px;">
									</el-input>
							    	<el-table
								    ref="my-re1"
								    :data="teamReimbursement"
								    tooltip-effect="dark"
								    style="width: 100%"
								    :summary-method="getSummaries"
    								show-summary
								    @selection-change="handleTeamSelectionChange">
								    <el-table-column
								      type="selection"
								      width="55">
								    </el-table-column>
								    <el-table-column
								      prop="name"
								      :label="$t('reimbursement.name')"
								      sortable
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="type"
								      :label="$t('reimbursement.type')"
								      sortable
								      width="120"
								      :filters="reimbursementTypeFilter"
      								  :filter-method="filterHandler">
								      <template slot-scope="scope">
								        {{ getReimbursementType(scope.row.type) }}
								      </template>
								    </el-table-column>
								    <el-table-column
								      prop="category"
								      :label="$t('reimbursement.category')"
								      sortable
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="legalEntityId"
								      :label="$t('reimbursement.legal-entity')"
								      sortable
								      width="150"
								      :filters="legalEntityFilter"
      								  :filter-method="filterHandler">
								      <template slot-scope="scope">
								        {{ getLegalEntity(scope.row.legalEntityId) }}
								      </template>
								    </el-table-column>
								    <el-table-column
								      prop="amount"
								      :label="$t('reimbursement.amount')"
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="invoiceDate"
								      :label="$t('reimbursement.invoice-date')"
								      sortable
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="createAt"
								      :label="$t('reimbursement.applied-date')"
								      sortable
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="status"
								      :label="$t('reimbursement.people')"
								      sortable
								      width="180"
								      >
      								  <template slot-scope="scope">
								        <span v-if="scope.row.personId != null">{{ scope.row.person.name }}@{{ scope.row.person.title }} of {{ scope.row.person.company }}</span>
								        <span v-else>&nbsp;</span>
								      </template>
								    </el-table-column>
								    <el-table-column
								      prop="status"
								      :label="$t('reimbursement.status')"
								      sortable
								      width="120"
								      :filters="reimbursementStatusFilter"
      								  :filter-method="filterHandler">
								      <template slot-scope="scope">
								        {{ getReimbursementStatus(scope.row.status) }}
								      </template>
								    </el-table-column>
								    <el-table-column
								      prop="comment"
								      :label="$t('reimbursement.comment')"
								      width="200">
								    </el-table-column>
								    <el-table-column
								      prop="my_accum"
								      :label="$t('reimbursement.my-accum')"
								      width="200">
								    </el-table-column>
								    <el-table-column
								      prop="my_left"
								      :label="$t('reimbursement.my-left')"
								      width="200">
								    </el-table-column>
								  </el-table>	
								  <el-row style="margin-top:20px">
									<el-button type="primary" @click="approveSelectedItems" :disabled="canApprove">{{ $t('reimbursement.approve') }}</el-button>
									<el-button type="info" @click="declineSelectedItems" :disabled="canDecline">{{ $t('reimbursement.decline') }}</el-button>
								  </el-row>
							    </el-tab-pane>
							    <el-tab-pane :label="$t('reimbursement.all')" name="3" v-if="userRole == 1">
							    	<el-input
									    :placeholder="$t('reimbursement.search-ph')"
									    prefix-icon="el-icon-search"
									    v-model="keyword"
									    style="width:250px;">
									</el-input>
							    	<el-table
								    ref="my-re2"
								    :data="allReimbursement"
								    tooltip-effect="dark"
								    style="width: 100%"
								    :summary-method="getSummaries"
    								show-summary
								    @selection-change="handleAllSelectionChange">
								    <el-table-column
								      type="selection"
								      width="55">
								    </el-table-column>
								    <el-table-column
								      prop="name"
								      :label="$t('reimbursement.name')"
								      sortable
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="type"
								      :label="$t('reimbursement.type')"
								      sortable
								      width="120"
								      :filters="reimbursementTypeFilter"
      								  :filter-method="filterHandler">
      								  <template slot-scope="scope">
								        {{ getReimbursementType(scope.row.type) }}
								      </template>
								    </el-table-column>
								    <el-table-column
								      prop="category"
								      :label="$t('reimbursement.category')"
								      sortable
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="legalEntityId"
								      :label="$t('reimbursement.legal-entity')"
								      sortable
								      width="150"
								      :filters="legalEntityFilter"
      								  :filter-method="filterHandler">
      								  <template slot-scope="scope">
								        {{ getLegalEntity(scope.row.legalEntityId) }}
								      </template>
								    </el-table-column>
								    <el-table-column
								      prop="amount"
								      :label="$t('reimbursement.amount')"
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="invoiceDate"
								      :label="$t('reimbursement.invoice-date')"
								      sortable
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="status"
								      :label="$t('reimbursement.people')"
								      sortable
								      width="180"
								      >
      								  <template slot-scope="scope">
								        <span v-if="scope.row.personId != null">{{ scope.row.person.name }}@{{ scope.row.person.title }} of {{ scope.row.person.company }}</span>
								        <span v-else>&nbsp;</span>
								      </template>
								    </el-table-column>
								    <el-table-column
								      prop="createAt"
								      :label="$t('reimbursement.applied-date')"
								      sortable
								      width="120">
								    </el-table-column>
								    <el-table-column
								      prop="status"
								      :label="$t('reimbursement.status')"
								      sortable
								      width="120"
								      :filters="reimbursementStatusFilter"
      								  :filter-method="filterHandler">
      								  <template slot-scope="scope">
								        {{ getReimbursementStatus(scope.row.status) }}
								      </template>
								    </el-table-column>
								    <el-table-column
								      prop="comment"
								      :label="$t('reimbursement.comment')"
								      width="200">
								    </el-table-column>
								    <el-table-column
								      prop="my_accum"
								      :label="$t('reimbursement.my-accum')"
								      width="200">
								    </el-table-column>
								    <el-table-column
								      prop="my_left"
								      :label="$t('reimbursement.my-left')"
								      width="200">
								    </el-table-column>
								  </el-table>	
								  <el-row style="margin-top:20px">
									<el-button type="primary" @click="approveSelectedItems" :disabled="canApprove">{{ $t('reimbursement.approve') }}</el-button>
									<el-button type="info" @click="declineSelectedItems" :disabled="canDecline">{{ $t('reimbursement.decline') }}</el-button>

									<el-button type="info" @click="paidSelectedItems" :disabled="canPaid">{{ $t('reimbursement.paid') }}</el-button>
								  </el-row>
							    </el-tab-pane>
							</el-tabs>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="" 
			:visible.sync="showReimbursementSheet"
			width="95%"
			top="30px"
			:append-to-body="true"
			:close-on-click-modal="false"
			:show-close="false">
			<div slot="title" class="header-title no-print">
	            {{ $t('reimbursement.re-sheet') }} <Help help="http://help.element-resources.com/admin/reimbursement.html#%E6%89%93%E5%8D%B0%E6%8A%A5%E9%94%80%E5%8D%95" />
            </div>
			<ReimbursementSheet :data="reimbursement" ref="re-sheet" />
			<div slot="footer" class="dialog-footer no-print">
			    <el-button @click="showReimbursementSheet = false">{{ $t('reimbursement.cancel') }}</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="$t('reimbursement.sign')" 
			:visible.sync="showSignPad"
			width="70%"
			top="30px"
			:append-to-body="true">
			<div class="dot-div">
			<VueSignaturePad width="100%" height="300px" ref="signaturePad" />
			</div>
			<div slot="footer" class="dialog-footer no-print">
			    <el-button @click="undo">{{ $t('reimbursement.undo') }}</el-button>
			    <el-button type="primary" @click="saveSignature">{{ $t('reimbursement.save2') }}</el-button>
			    <el-button @click="showSignPad = false">{{ $t('reimbursement.cancel') }}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<style scoped>
@media print {
 	.no-print { display:none; }
}
.dot-div {
	border: 1px dashed #333;
}
</style>
<script>
// @ is an alias to /src
import { Loading } from 'element-ui'
import ReimbursementSheet from '@/components/finance/ReimbursementSheet.vue'
import Help from '@/components/common/Help.vue'

export default {
  name: 'PaymentList',
  components: {
    ReimbursementSheet,
    Help
  },
  props: ['message'],
  data: function() {
	return {
	  activeTab: '1',
	  numPerPage: 25,
	  reimbursement: {},
	  filteredData: {},
	  searchCriteria: {
	    date: [],
	    keyword: null
	  },
	  keyword: null,
	  keyword1: null,
	  sum: [0, 0, 0, 0],
	  canPrint: false,
	  selectedItems: [],
	  delConfirm: false,
	  teamSelectedItems: [],
	  allSelectedItems: [],
	  showReimbursementSheet: false,
	  showSignPad: false
	}
  },
  computed: {
    userRole: function() {
      return localStorage.getItem('role')
    },
    allReimbursement: function() {
      let k = this.keyword ? this.keyword.toLowerCase() : ''
      if (!this.reimbursement.all) return []
      return this.reimbursement.all.filter(item => {
		/*if ((item.name && item.name.toLowerCase().includes(k)) || (item.category && item.category.toLowerCase().includes(k)) || (item.comment && item.comment.toLowerCase().includes(k)) || (item.invoiceDate && item.invoiceDate.toLowerCase().includes(k)) || (item.amount && item.amount.toString().includes(k))) {
		  return item
		}*/
		if ((item.name && item.name.toLowerCase().includes(k))) {
		  return item
		}
	  })
    },
    teamReimbursement: function() {
      let k = this.keyword1 ? this.keyword1.toLowerCase() : ''
      if (!this.reimbursement.team) return []
      return this.reimbursement.team.filter(item => {
		/*if ((item.name && item.name.toLowerCase().includes(k)) || (item.category && item.category.toLowerCase().includes(k)) || (item.comment && item.comment.toLowerCase().includes(k)) || (item.invoiceDate && item.invoiceDate.toLowerCase().includes(k)) || (item.amount && item.amount.toString().includes(k))) {
		  return item
		}*/
		if ((item.name && item.name.toLowerCase().includes(k))) {
		  return item
		}
	  })
    },
    legalEntityFilter: function() {
      let f = []
      for (let i = 0; i < this.legalEntity.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.legalEntity[i]['c_name'] : this.legalEntity[i]['e_name'],
          value = this.legalEntity[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    },
    reimbursementStatusFilter: function() {
      let f = []
      for (let i = 0; i < this.reimbursementStatus.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.reimbursementStatus[i]['c_name'] : this.reimbursementStatus[i]['e_name'],
          value = this.reimbursementStatus[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    },
    reimbursementTypeFilter: function() {
      let f = []
      for (let i = 0; i < this.reimbursementType.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.reimbursementType[i]['c_name'] : this.reimbursementType[i]['e_name'],
          value = this.reimbursementType[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    },
    canPaid: function() {
      let data = (this.activeTab == 2) ? this.teamSelectedItems : this.allSelectedItems
      if (data.length == 0)
        return true
      else {
        for (let i = 0; i < data.length; i++) {
          if (data[i].status == 1)
            return false
        }
        return true
      }
    },
    canDelete: function() {
      if (this.selectedItems.length == 0)
        return true
      else {
        for (let i = 0; i < this.selectedItems.length; i++) {
          if (this.selectedItems[i].status == 0)
            return false
        }
        return true
      }
    },
    canApprove: function() {
      let data = (this.activeTab == 2) ? this.teamSelectedItems : this.allSelectedItems
      if (data.length == 0)
        return true
      else {
        for (let i = 0; i < data.length; i++) {
          if (data[i].status == 0)
            return false
        }
        return true
      }
    },
    canDecline: function() {
      let data = (this.activeTab == 2) ? this.teamSelectedItems : this.allSelectedItems
      if (data.length == 0)
        return true
      else {
        for (let i = 0; i < data.length; i++) {
          if (data[i].status == 0)
            return false
        }
        return true
      }
    }
  },
  watch: {
  	
  },
  methods: {
    undo: function() {
      this.$refs.signaturePad.undoSignature()
    },
    saveSignature: function() {
      let that = this
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      
      if (!isEmpty) {
        let q = {
          'userId': localStorage.getItem('token'),
          'sign': data
        }
        console.log(data)
        this.$http.post(this.API3_PREFIX + 'save_sign', q).then(function (response) {
          that.showSignPad = false
        }).catch(function (error) {
          console.log(error)
          that.$message({
            message: that.$t('reimbursement.sign-failed'),
            type: 'error'
          })
        })
      }      
    },
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    handleCellEvent: function(row, column, cell, event) {
      this.$router.push({ path: '/reimbursement/edit/' + row.id })
    },
    paidSelectedItems: function() {
      let data = (this.activeTab == 2) ? this.teamSelectedItems : this.allSelectedItems,
          d = {
            'ids': [],
            'status': 4,
            'type': 'reimbursement',
            'oldStatus': 1,
            'userId': localStorage.getItem('token')
          },
          that = this
      data.forEach(function(v, i) {
        if (v.status == 1)
          d['ids'].push(v.id)
      })
      this.$http.post(this.API3_PREFIX + 'status', d).then(function (response) {
          that.$message({
            message: that.$t('reimbursement.paid-success'),
            type: 'success'
          })
          //change status for original data
          data.forEach(function(v, i) {
            v.status = 4
            v.statusName = that.getReimbursementStatus(v.status)
          })
        }).catch(function (error) {
          console.log(error)
          that.$message({
            message: that.$t('reimbursement.paid-failed'),
            type: 'error'
          })
        })
    },
    approveSelectedItems: function() {
      let data = (this.activeTab == 2) ? this.teamSelectedItems : this.allSelectedItems,
          d = {
            'ids': [],
            'status': 1,
            'type': 'reimbursement',
            'oldStatus': 0,
            'userId': localStorage.getItem('token')
          },
          that = this
      data.forEach(function(v, i) {
        if (v.status == 0)
          d['ids'].push(v.id)
      })
      this.$http.post(this.API3_PREFIX + 'status', d).then(function (response) {
          that.$message({
            message: that.$t('reimbursement.approve-success'),
            type: 'success'
          })
          //change status for original data
          data.forEach(function(v, i) {
            v.status = 1
            v.statusName = that.getReimbursementStatus(v.status)
          })          
          that.$nextTick(() => {
		    that.showSignPad = true
		  })
        }).catch(function (error) {
          console.log(error)
          that.$message({
            message: that.$t('reimbursement.approve-failed'),
            type: 'error'
          })
        })
    },
    declineSelectedItems: function() {
      let data = (this.activeTab == 2) ? this.teamSelectedItems : this.allSelectedItems,
          d = {
            'ids': [],
            'status': 2,
            'type': 'reimbursement',
            'oldStatus': 0,
            'userId': localStorage.getItem('token')
          },
          that = this
      data.forEach(function(v, i) {
        if (v.status == 0)
          d['ids'].push(v.id)
      })
      this.$http.post(this.API3_PREFIX + 'status', d).then(function (response) {
          that.$message({
            message: that.$t('reimbursement.decline-success'),
            type: 'success'
          })
          //change status for original data
          data.forEach(function(v, i) {
            v.status = 2
            v.statusName = that.getReimbursementStatus(v.status)
          })
        }).catch(function (error) {
          console.log(error)
          that.$message({
            message: that.$t('reimbursement.decline-failed'),
            type: 'error'
          })
        })
    },
    deleteSelectedItems: function() {
      let data = this.selectedItems,
          d = {
            'userId': localStorage.getItem('token'),
            'ids': [],
            'source': 'reimbursement'
          },
          that = this
      data.forEach(function(v, i) {
        if (v.status == 0)
          d['ids'].push(v.id)
      })
      this.$http.post(this.API3_PREFIX + 'del_records', d).then(function (response) {
          that.$message({
            message: that.$t('reimbursement.delete-success'),
            type: 'success'
          })
          //remove for original data
          data.forEach(function(v, i) {
            for (let i = 0; i < that.reimbursement.my.length; i ++) {
              if (that.reimbursement.my[i].id == v.id)
                that.reimbursement.my.splice(i,1)
            }
          })
        }).catch(function (error) {
          console.log(error)
          that.$message({
            message: that.$t('reimbursement.delete-failed'),
            type: 'error'
          })
        })
      this.delConfirm = false
    },
    getSummaries: function(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = this.$t('reimbursement.sum')
          return
        } else if ((index == 5 || index == 6) && this.activeTab == 1) {
          sums[index] = ''
          return
        } else if ((index == 4 || index == 6 || index == 7) && (this.activeTab == 3 || this.activeTab == 2)) {
          sums[index] = ''
          return
        }
        const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            if (sums[index] != 0)
              sums[index] = sums[index].toFixed(2) + ' ' + this.$t('reimbursement.unit')
            else
              sums[index] = '';
          } else {
            sums[index] = ''
          }
        })
        return sums;
    },
    printReimbursementSheet: function() {
      this.showReimbursementSheet = true
    },
    handleSelectionChange: function(val) {
      //console.log(val)
      this.selectedItems = val
    },
    handleTeamSelectionChange: function(val) {
      this.teamSelectedItems = val
    },
    handleAllSelectionChange: function(val) {
      this.allSelectedItems = val
    },
    createNew: function() {
      this.$router.push({ path: '/reimbursement/new' })
    },
    filterList: function() {
      
    },
    loadData: function() {
      let that = this,
          userId = localStorage.getItem('token'),
          loading = Loading.service({ fullscreen: true })

	  this.$http.get(this.API3_PREFIX + 'reimbursement_list?userId=' + userId).then(function (response) {
		that.reimbursement = response.data
		let approved = [],
			ts = 0.0
        that.reimbursement['my'].forEach(function(p, i) {
          if (p.legalEntityId != null)
            p.legalEntity = that.getLegalEntity(p.legalEntityId)
          else
            p.legalEntity = null
          p.statusName = that.getReimbursementStatus(p.status)
          if (p.costCategory.length > 0 && p.type == 1)
            p.category = that.getCostCategory(p.costCategory)
          else if (p.type == 0 && p.expenseCategory != null)
            p.category = that.getExpenseCategory(p.expenseCategory)
          else
            p.category = null
          p.typeName = that.getReimbursementType(p.type)
          if (p.status == 1) {
            that.canPrint = false
            ts += p.amount
            approved.push(p)
          }
          that.sum[1] += p.amount
        })
        that.reimbursement['approved'] = approved
        that.reimbursement['sum'] = ts.toFixed(2)
        that.reimbursement['team'].forEach(function(p, i) {
          if (p.legalEntityId != null)
            p.legalEntity = that.getLegalEntity(p.legalEntityId)
          else
            p.legalEntity = null
          p.statusName = that.getReimbursementStatus(p.status)
          if (p.costCategory.length > 0 && p.type == 1)
            p.category = that.getCostCategory(p.costCategory)
          else if (p.type == 0 && p.expenseCategory != null)
            p.category = that.getExpenseCategory(p.expenseCategory)
          else
            p.category = null
          p.typeName = that.getReimbursementType(p.type)
          that.sum[2] += p.amount
        })
        that.reimbursement['all'].forEach(function(p, i) {
          if (p.legalEntityId != null)
            p.legalEntity = that.getLegalEntity(p.legalEntityId)
          else
            p.legalEntity = null
          p.statusName = that.getReimbursementStatus(p.status)
          if (p.costCategory.length > 0 && p.type == 1)
            p.category = that.getCostCategory(p.costCategory)
          else if (p.type == 0 && p.expenseCategory != null)
            p.category = that.getExpenseCategory(p.expenseCategory)
          else
            p.category = null
          p.typeName = that.getReimbursementType(p.type)
          that.sum[3] += p.amount
        })
		that.$nextTick(() => {
		  loading.close()
		})
      }).catch(function (error) {
		console.log(error)
		that.$nextTick(() => {
		  loading.close()
		})
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>